<div class="tab-group">
  <mat-tab-group class="booking-details veiw-booking-details" animationDuration="0ms"
    (selectedTabChange)="onTabClick($event)">

    <!--Extra(s)-->
    <mat-tab label="{{ 'Extras' | translate }}">
      <h2>
        <div class="selected-class-title">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faClipboard"></fa-icon>
          {{ 'AdditionalServices' | translate }}
        </div>
      </h2>
      <div class="ml-3">
        <ng-container *ngFor="let additionalService of lstAdditionalServiceReservationCaseTypeService">
          <container-element [ngSwitch]="additionalService.predefinedAdditionalServiceID">

            <!--Start Additional Driver-->
            <div class="row mb-3" *ngSwitchCase="predefinedAdditionalServiceEnum.AdditionalDrivers">
              <div class="col-md-12 pl-0">
                <div class="d-flex margins-view">
                  <div class="detail-title ml-4">
                    <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    <!-- <img class="icon-extra" src="assets/img/icon-extra.png" /> -->
                    {{additionalService.serviceName}}
                    <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                    <!-- <div class="description">{{additionalService.description}} </div> -->
                  </div>
                  <input  disabled type="text" type="number" [value]="additionalService.totalQuantityUsedForCase"
                    class="form-control form-control-number ml-auto" placeholder="0">
                </div>
              </div>
            </div>
            <!--End Additional Driver-->

            <!--Start Crossing Borders-->
            <div class="row mb-3" *ngSwitchCase="predefinedAdditionalServiceEnum.CrossingBoarders">
              <div class="col-md-12 pl-0">
                <div class="detail-title ml-4">
                  <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                </div>
                <div class="d-flex ml-4 align-items-center service-view mt-2"
                  *ngFor="let border of additionalService.lstCrossBorderModel">
                  <div class="crossingBorder mr-2">{{border.borderPortName}}</div>
                  <div class="crossingBorderDescription"><span class="ml-2">{{ 'PassPermit' | translate }}</span><span
                      class="ml-2">{{ 'AdditionPermission' | translate }}</span></div>
                  <div class="ml-auto mb-2">
                    <input disabled type="text" formControlName="BorderValue" [value]="border.charge"
                      class="form-control form-control-number ml-auto" placeholder="0" aria-label="driverInformation">
                  </div>
                </div>


              </div>
            </div>
            <!--End Crossing Borders-->

            <!--Start Drivers-->
            <div class="row mb-3" *ngSwitchCase="predefinedAdditionalServiceEnum.Drivers">
              <div class="col-md-12 pl-0">
                <div class="d-flex">
                  <div class="detail-title ml-4">
                    <img class="icon-extra"
                    [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                    <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                  </div>
                </div>
                <div class="d-flex ml-4 align-items-center service-view mt-2">

                  <div *ngIf="!driverSkills==null || !driverSkills.length == 0">
                    <span>{{ 'Skills' | translate }}</span>
                    <div class="crossingBorder ml-3" *ngFor="let skill of driverSkills">{{skill.driverSkillName}}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!--End Drivers-->

            <!--Start One Way Rental-->
            <div class="row mb-3" *ngSwitchCase="predefinedAdditionalServiceEnum.OneWayRentalService">
              <div class="col-md-12 pl-0">
                <div class="detail-title ml-4">
                  <img class="icon-extra"
                  [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                  {{additionalService.serviceName}}
                </div>
                <div class="d-flex ml-4 align-items-center service-view">
                  <div class="crossingBorder mr-2 ">{{viewBooking.oneWayRental}}</div>
                  <div class="ml-auto mb-2">
                    <input disabled type="text" type="number" [value]="additionalService.unitPrice"
                      class="form-control form-control-number ml-auto" placeholder="0" aria-label="driverInformation">
                  </div>
                </div>
              </div>
            </div>
            <!--End One Way Rental-->


            <!--Start Agent Delivery Service-->
            <div class="row mb-3" *ngSwitchCase="predefinedAdditionalServiceEnum.RentalDelivery">
              <div class="col-md-12 pl-0">
                <div class="detail-title ml-4">
                  <img class="icon-extra"
                  [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                   {{additionalService.serviceName}}
                </div>
                <div class="d-flex flex-wrap ml-4 align-items-center service-view" *ngIf="viewBooking.isPickupAddress">
                  <div class="mr-3">{{ 'Pickup' | translate }}</div>
                  <div class="detail-price l-25 mr-3">{{additionalService.pickupUnitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></div>
                  <div ><a class="location" (click)="openMapDialog(1)">{{viewBooking.pickupAddress}}</a></div>
                </div>

                <div class="d-flex flex-wrap ml-4 align-items-center service-view" *ngIf="viewBooking.isReturnAddress">
                  <div class="mr-3  return-ar">{{ 'Return' | translate }}</div>
                  <div class="detail-price l-25 mr-3">{{additionalService.returnUnitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></div>
                  <div><a class="location" (click)="openMapDialog(2)">{{viewBooking.returnAddress}}</a></div>
                </div>

              </div>
            </div>
            <div *ngSwitchDefault>
              <!--IsAddOn-->
              <div class="row mb-3" *ngIf="additionalService.isPhysicalAddon">
                <div class="col-md-12 pl-0">
                  <div class="d-flex margins-view">
                    <div class="detail-title ml-4">
                      <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                       {{additionalService.serviceName}}
                      <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                      <!-- <div class="description">{{additionalService.description}} </div> -->
                    </div>
                    <input disabled type="text" type="number" [value]="additionalService.totalQuantityUsedForCase"
                      class="form-control form-control-number ml-auto" placeholder="0">
                  </div>
                </div>
              </div>
              <!-- Else-->
              <div class="row mb-3" *ngIf="!additionalService.isPhysicalAddon">
                <div class="col-md-12 pl-0">
                  <div class="d-flex">
                    <div class="detail-title ml-4">
                      <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.additionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                       {{additionalService.serviceName}}
                      <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                      <!-- <div class="description">{{additionalService.description}} </div> -->
                    </div>
                  </div>
                </div>
              </div>




            </div>

          </container-element>
        </ng-container>
        <ng-container
          *ngIf="lstAdditionalServiceReservationCaseTypeService==null || lstAdditionalServiceReservationCaseTypeService.length ==0">
          <p class="no-available-info no-selected-AdditionalServices"><i class="fas fa-info-circle mr-1"></i> {{
            'NoSelectedAdditionalServices' | translate }}</p>
        </ng-container>

      </div>

      <h2 class="mt-5">
        <div class="selected-class-title">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faDollarSign"></fa-icon>
          {{ 'AdditionalCharge' | translate }}
        </div>
      </h2>
      <ng-container
        *ngIf="lstAdditionalServiceReservationCaseTypeCharge!=null && lstAdditionalServiceReservationCaseTypeCharge.length >0">


        <div class="ml-3" *ngFor="let additionalService of lstAdditionalServiceReservationCaseTypeCharge">
          <div class="row mb-3">
            <div class="col-md-12 pl-0">
              <div class="d-flex">
                <div class="detail-title ml-4">
                  <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}

                  <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                  <!-- <div class="description">{{additionalService.description}} </div> -->
                </div>
              </div>
            </div>
          </div>

        </div>
      </ng-container>
      <ng-container
        *ngIf="lstAdditionalServiceReservationCaseTypeCharge==null || lstAdditionalServiceReservationCaseTypeCharge.length ==0">
        <p class="no-available-info no-selected-AdditionalCharges"><i class="fas fa-info-circle mr-1"></i> {{
          'NoSelectedAdditionalCharges' | translate }}</p>
      </ng-container>
    </mat-tab>


    <!--Driver Information-->
    <mat-tab label="{{ 'Driver' | translate }}">
      <div class="col-lg-10 col-md-12 p-0">

        <!--Name-->
        <div class="form-group row">
          <label class="col-12">{{ 'Name' | translate }}</label>
          <div class="col-md-12">{{customerSummary.defaultName}}</div>
        </div>

        <!--Date of Birth-->
        <div class="form-group row">
          <label class="col-12">{{ 'DateofBirth' | translate }}</label>
          <div class="col-md-12">
            <fa-icon class="mr-1 fa-s" [icon]="faCalendarAlt"></fa-icon>{{customerSummary.dobFormated}}
          </div>
        </div>

        <!--Email-->
        <div class="form-group row">
          <label class="col-12">{{ 'Email' | translate }}</label>
          <div class="col-md-12">{{customerSummary.primaryEmail}}</div>
        </div>

        <!--Mobile Number-->
        <div class="form-group row">
          <label class="col-12">{{ 'MobileNumber' | translate }}</label>
          <div class="col-md-12 number-ltr">
            {{customerSummary.mobile1}}
          </div>
        </div>

        <div class="note-bg mt-3">
          <p>{{ 'AllAdditionalDriversInformationShouldBeDefinedAtPickup' | translate }}</p>
          <p>{{ 'AllInformationRelatedIdentityCard' | translate }}</p>
        </div>

      </div>
    </mat-tab>

    <!--The index of -->
    <!--The Index of payemnt is used in the .ts file (onTabClick) please reflect all modification insace of any changes-->
    <!--Payments-->
    <mat-tab label="{{ 'Payments' | translate }}" id="payment">

      <ng-container *ngIf="tabIndedx==2">
        <div *ngIf="!clickPay">
          <div class="payment-box p-3" *ngIf="accountStatment!=null">
            <div class="row">
              <div class="col-md-6 col-12   row">
                <div class="col-md-6 col-6 mt-2">
                  <div class="mb-1">
                    <span class="text-blue payment-title mr-3">{{ 'Balance' | translate }} </span>
                  </div>
                  <!-- <div class="mb-1">
                  <span class="text-blue payment-title mr-3">{{ 'CreditBalance' | translate }} </span>
                </div>
                <div>
                  <span class="text-blue payment-title mr-3">{{ 'Debit' | translate }} </span>
                </div> -->
                </div>
                <div class="col-md-6 col-6 mt-2">
                  <div class="mb-2">
                    {{accountStatment.sumBalance | number}}
                    {{currency}}
                  </div>
                  <!-- <div class="mb-2">
                  {{accountStatment.sumCredit}} {{currency}}
                </div>
                <div>
                  {{accountStatment.sumDebit}} {{currency}}
                </div> -->
                </div>
              </div>

              <div *ngIf="accountStatment.sumBalance > 0">
                <button (click)="openPayModal()" class="btn default-btn">{{ 'Pay' | translate }}</button>
              </div>

            </div>
          </div>

          <div class="table-style example-container mat-elevation-z8">
            <mat-table [class.isMobile]="isMobile"  class="border" #table [dataSource]="paymentModel">

              <!-- ReceiptNo Column -->
              <ng-container matColumnDef="ReceiptNo">
                <mat-header-cell *matHeaderCellDef> {{ 'ReceiptNo.' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <button class="btn btn-icon" (click)="printClicked(element)">
                    <span class="text-blue"><span class="mobile-label">{{ 'ReceiptNo.' | translate }}:</span> {{element.receiptNo}}</span>
                  </button>
                </mat-cell>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="Date">
                <mat-header-cell *matHeaderCellDef>{{ 'Date' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="mobile-label">{{ 'Date' | translate }}:</span> {{element.paymentDateString}} </mat-cell>
              </ng-container>

              <!-- Method Column -->
              <ng-container matColumnDef="Method">
                <mat-header-cell *matHeaderCellDef> {{ 'Method' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="mobile-label">{{ 'Method' | translate }}:</span> {{element.paymentMethodName}}</mat-cell>
              </ng-container>


              <!-- Amount Column -->
              <ng-container matColumnDef="Amount">
                <mat-header-cell *matHeaderCellDef> {{ 'Amount' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="mobile-label">{{ 'Amount' | translate }}:</span>  {{element.amount | number}} {{currency}}</mat-cell>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          </div>
          <div class="text-center no-payment-added" *ngIf="this.paymentModel!=null &&this.paymentModel.length == 0">
              {{ 'NoPaymentHasBeenAddedYet' | translate }}
          </div>
        </div>



        <!--Pay Content-->
        <div *ngIf="clickPay">
          <pay-modal [viewBooking]="viewBooking" (onCancel)="changeViewType()"></pay-modal>
        </div>

      </ng-container>


    </mat-tab>

    <!--Policies-->
    <mat-tab label="{{ 'Policies' | translate }}">
      <ng-container *ngIf="viewBooking!=null && viewBooking.lstPolicyReservationCaseModel!=null">
        <policies [lstPolicyReservationCaseModel]="viewBooking.lstPolicyReservationCaseModel"></policies>
      </ng-container>
    </mat-tab>

    <!--Reviews-->
    <mat-tab label="{{ 'Reviews' | translate }}">
      <view-reviews [vehicle]="vehicle"></view-reviews>
    </mat-tab>

    <!--Terms & Conditions-->
    <mat-tab label="{{ 'TermsAndConditions' | translate }}">
      <terms-and-conditions></terms-and-conditions>

    </mat-tab>

  </mat-tab-group>
</div>







<!--------------------------->

<div class="recipt-border">
  <div class="row">
    <div class="col-6">
      <img class="mr-auto  recipt-logo mt-2" [src]="logo" [alt]="logo.name">
    </div>
    <div *ngIf="recivedPaymentModel != null" class="col-6">
      <div class="recipt-info mt-3">
        <div>{{recivedPaymentModel.OwnerAgencyName}}</div>
        <div class="mb-2">{{recivedPaymentModel.ownerAgencyAddress}}</div>
        <div class="phone-num">{{recivedPaymentModel.ownerAgencyPhoneNo}}</div>
        <div>{{recivedPaymentModel.ownerAgencyEmail}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="recivedPaymentModel != null" class="row">
    <div class="col-md-12">
      <div class="receipt">
        <div class="receipt-title"> {{ 'Payment' | translate }} {{ 'RecivedPaymentReceipt' | translate }}</div>
        <div class="receipt-body">
          <div class="row mb-2">
            <div class="col-md-6 ">
              <div><span class="infoLabel">{{ 'ReceiptNumber' | translate }}: {{recivedPaymentModel.receiptNo}}</span>
              </div>
              <div class="mb-2"><span class="infoLabel">{{ 'PaidBy' | translate }}:
                </span>{{recivedPaymentModel.paidByName}}</div>
            </div>
            <div class="col-md-6">
              <div><span class="infoLabel">{{ 'PaidOn' | translate }}: </span>{{recivedPaymentModel.paymentDateString}}
              </div>
              <div class="mb-2"><span class="infoLabel">{{ 'ReceivedBy' | translate }}:
                </span>{{recivedPaymentModel.receivedByAgencyName}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 ">
              <div><span class="infoLabel">{{ 'Amount' | translate }}: </span>{{recivedPaymentModel.amount | number}}{{currency}}
              </div>
              <div><span class="infoLabel">{{ 'PaymentMethod' | translate }}:
                </span>{{recivedPaymentModel.paymentMethodName | translate}}</div>
              <div><span class="infoLabel">{{ 'PaymentType' | translate }}:
                </span>{{recivedPaymentModel.paymentTypesName | translate}}</div>
            </div>
            <div class="col-md-6">
              <div><span class="infoLabel">{{ 'Service' | translate }}: </span>{{ 'Rental' | translate }} –
                {{recivedPaymentModel.bookingNumberFormatted}}</div>
              <div><span class="infoLabel">{{ 'Branch' | translate }}: </span> {{recivedPaymentModel.ownerAgencyName |
                translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--------------------------->
